import {
  USER_VERIFICATION_STATUS,
  COMPANY_VERIFICATION_STATUS,
  ACCOUNT_TYPE,
  PASSED_VERIF_STATUS
} from "src/consts/user";
import { DEPOSIT_ACTIVATION_STATUS } from "src/consts/deposit";

import { getSafely } from "src/helpers/object";
import { KYC_STATUS } from "src/scenes/NewVerification/consts/kyc";
import { TRIAL_ACTIVE } from "src/scenes/Home/consts";

export function isCompanyUser(user) {
  return getSafely(["company", "account_type"], user) === ACCOUNT_TYPE.COMPANY;
}

export function isVerificationPassed(user) {
  if (!user || Object.keys(user).length === 0) return PASSED_VERIF_STATUS.PENDING;

  const isAllowedTrx = getSafely(["allowed_create_transaction"], user);
  const isEmailVerified = getSafely(["user_owner", "email_verified"], user);
  const isPhoneVerified = getSafely(["user_owner", "phone_number_verified"], user);
  const isEmailPhoneVerified = isAllowedTrx && isEmailVerified && isPhoneVerified;

  const identityStatus = getSafely(["user_owner", "identity_verifications_status"], user);
  const isUserVerified = isEmailPhoneVerified && identityStatus === USER_VERIFICATION_STATUS.DONE;

  if (isCompanyUser(user)) {
    const companyStatus = getSafely(["company", "identity_verifications_status"], user);

    return isUserVerified && companyStatus === COMPANY_VERIFICATION_STATUS.DONE
      ? PASSED_VERIF_STATUS.PASSED
      : PASSED_VERIF_STATUS.NOT_PASSED;
  }
  return isUserVerified ? PASSED_VERIF_STATUS.PASSED : PASSED_VERIF_STATUS.NOT_PASSED;
}

export function isDepositActive(user) {
  return (
    typeof user.company?.deposit_status !== "undefined" &&
    user.company?.deposit_status === DEPOSIT_ACTIVATION_STATUS.ACTIVE
  );
}

/**
 * Returns true if user's company is on trial
 */
export function isUserOnTrial(trial) {
  if (!trial || Object.keys(trial).length === 0) return false;

  return trial.transaction_status === TRIAL_ACTIVE && trial.expired_at !== "" && trial.started_at !== "";
}

/**
 * Returns true if the company needs to complete the verification
 */
export function isVerificationNeeded(companyKycStatus) {
  return ![
    KYC_STATUS.CANCELLED,
    KYC_STATUS.DONE,
    KYC_STATUS.WAITING_APPROVAL,
    KYC_STATUS.REJECTED,
    KYC_STATUS.APPROVED,
    KYC_STATUS.REQUESTED,
    KYC_STATUS.NEGOTIATE
  ].includes(companyKycStatus);
}
